import styled from 'styled-components';

export const EmbedMainWrapper = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    padding-top: 20px;
`;
